import React from 'react';
import { motion } from 'framer-motion';
import { Section } from './ui/Section';
import { Eye, Mic, FileText, Cpu } from 'lucide-react';
export function MechanismSection() {
  const pillars = [{
    letter: 'V',
    title: 'Visual',
    tool: 'Midjourney',
    icon: <Eye size={32} className="text-brand-cyan" data-id="element-164" />,
    desc: 'Estética visual impecable y coherente que captura la atención instantáneamente.'
  }, {
    letter: 'A',
    title: 'Audio',
    tool: 'ElevenLabs',
    icon: <Mic size={32} className="text-brand-purpleLight" data-id="element-165" />,
    desc: 'Psicología de voz clonada que transmite autoridad, emoción y confianza humana.'
  }, {
    letter: 'S',
    title: 'Script',
    tool: 'ChatGPT',
    icon: <FileText size={32} className="text-brand-cyan" data-id="element-166" />,
    desc: 'Narrativa de retención diseñada con ingeniería inversa para maximizar el engagement.'
  }];
  return <Section className="relative" data-id="element-167">
      <div className="absolute right-0 top-1/2 -translate-y-1/2 w-1/2 h-1/2 bg-brand-cyan/10 blur-[150px] -z-10 pointer-events-none" data-id="element-168" />

      <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-169">
        <div className="inline-flex items-center justify-center p-4 glass-card rounded-2xl mb-6 border-brand-cyan/30 text-brand-cyan shadow-[0_0_30px_rgba(0,240,255,0.2)]" data-id="element-170">
          <Cpu size={40} data-id="element-171" />
        </div>
        <h2 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-172">
          El Método{' '}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-brand-cyan to-brand-purple" data-id="element-173">
            "Ghost AI"
          </span>
          <span className="block text-2xl md:text-3xl mt-2 text-white/70 font-medium" data-id="element-174">
            (V.A.S. Framework)
          </span>
        </h2>
      </div>

      <motion.div className="glass-card p-8 md:p-12 rounded-3xl border-brand-cyan/40 shadow-[0_0_50px_rgba(0,240,255,0.1)] relative overflow-hidden mb-16" initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} data-id="element-175">
        <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-brand-cyan via-brand-purple to-brand-cyan" data-id="element-176" />
        <p className="text-xl md:text-2xl text-center text-white/90 leading-relaxed" data-id="element-177">
          Este sistema no utiliza la IA para "escribir posts", sino para
          construir una{' '}
          <strong className="text-brand-cyan font-bold" data-id="element-178">
            Identidad Sintética de Autoridad
          </strong>
          . Combinamos la estética visual de Midjourney, la psicología de voz de
          ElevenLabs y la narrativa de retención de ChatGPT para crear un
          ecosistema de contenido que se siente humano, pero es 100%
          automatizado.
          <br data-id="element-179" />
          <br data-id="element-180" />
          <span className="text-brand-purpleLight font-semibold" data-id="element-181">
            Tú dejas de ser el actor para convertirte en el Director de
            Orquesta.
          </span>
        </p>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-182">
        {pillars.map((pillar, index) => <motion.div key={index} className="glass-card-glow p-8 rounded-2xl border-white/10 flex flex-col items-center text-center group" initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: index * 0.2
      }} data-id="element-183">
            <div className="w-20 h-20 rounded-full bg-brand-darker border border-white/10 flex items-center justify-center mb-6 relative z-10 group-hover:scale-110 transition-transform duration-300 shadow-lg" data-id="element-184">
              <span className="absolute -top-3 -right-3 w-8 h-8 rounded-full bg-gradient-to-br from-brand-cyan to-brand-purple flex items-center justify-center text-sm font-bold shadow-[0_0_15px_rgba(0,240,255,0.5)]" data-id="element-185">
                {pillar.letter}
              </span>
              {pillar.icon}
            </div>
            <h3 className="text-2xl font-bold mb-2 relative z-10" data-id="element-186">
              {pillar.title}
            </h3>
            <div className="text-sm font-mono text-brand-cyan mb-4 relative z-10 bg-brand-cyan/10 px-3 py-1 rounded-full" data-id="element-187">
              Powered by {pillar.tool}
            </div>
            <p className="text-brand-gray relative z-10" data-id="element-188">{pillar.desc}</p>
          </motion.div>)}
      </div>
    </Section>;
}